import { render, staticRenderFns } from "./main-header.vue?vue&type=template&id=27fa4a40"
import script from "./main-header.vue?vue&type=script&lang=js"
export * from "./main-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports